import React from 'react';
import {Link} from 'react-router-dom';

import {DocumentList, File} from 'components/documents';


export const DocumentInformation = ({ document }) => (
  <DocumentList>
    <File>Документ: <Link style={{color: "#da9c15", textDecoration: "underline"}} to={`/admin/documents/detail/${document.get('id')}`}><strong>{document.get('name')}</strong></Link></File>
    <li>Номер документа: <strong>{document.get('number')}</strong></li>
    <li>Автор документа: <strong>{document.get('author_data').get('last_name')} {document.get('author_data').get('first_name')}</strong></li>
  </DocumentList>

)



// WEBPACK FOOTER //
// ./src/admin/mailing/detail/document-information.js